import { motion } from "framer-motion";
import { FaUserDoctor } from "react-icons/fa6";

function DoctorDetails({ doctor }) {
  const availabilityHours = doctor?.availibility
    ? (doctor.availibility.hours)
    : { start: "", end: "" };

  return (
    <div className="overflow-auto h-full" style={{ paddingBottom: '5rem'}}>
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        exit={{ opacity: 0, x: -50 }}
        className=" px-9 text-2xl pt-3 text-[#04225b] mb-3 font-semibold"
      >
        Doctor Details
      </motion.div>

      <div className=" flex flex-col px-9 gap-x-10 gap-y-9">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          exit={{ opacity: 0, y: -50 }}
          className=" grid grid-cols-2 gap-y-3 px-6  py-10 bg-white rounded-xl shadow-lg border border-gray-100 "
        >
          <div className=" col-span-2 text-center mb-5">
            {" "}
            {/* <img
                src="../images/healthcare.png"
                className=" w-24 h-24 shadow-lg rounded-full mx-auto"
              /> */}
            <div className=" w-[119px] h-[119px] shadow-lg rounded-full mx-auto flex justify-center items-center text-[60px] border border-gray-50 text-[#04225b]">
              <FaUserDoctor />
            </div>
          </div>
          <strong>Name: </strong>
          <span>
            {doctor?.name}
            {doctor?.full_name}
          </span>
          <strong>Speciality:</strong>
          <span>{doctor?.doctor_speciality}</span>
          <strong>Qualification:</strong>
          <span>{doctor?.doctor_qualification}</span>
          <strong>Phone Number:</strong>{" "}
          <span>
            {doctor?.primary_phone_number}
            {doctor?.phone_number}
          </span>
          <strong>Email:</strong>
          <span>{doctor?.primary_email_id}</span>
          <strong>Consultation Fees:</strong>
          <span>{doctor?.consultation_fees}</span>
          <strong>Experience:</strong>
          <span>{doctor?.experience} years</span>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          exit={{ opacity: 0, x: 50 }}
          className="w-full"
        >
          <div className=" bg-[#1a76d1] px-6 py-6 rounded-xl shadow-lg">
            <div className=" text-xl font-semibold text-white">
              Working Hours
            </div>
            <div>
              {doctor?.availibility?.days ? (
                <ul className="gap-y-2 flex flex-col mt-3">
                  {Object.entries(availabilityHours).sort(([day1], [day2]) => {
                      const order = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
                      return order.indexOf(day1) - order.indexOf(day2);
                    })?.map(([day, hours], index) => (
                      <li key={index} className="flex justify-between text-white text-sm capitalize">
                        <span>{day} -</span>
                        <span>
                          {hours.length > 0 ? (
                            <>
                              {hours[0]?.start && hours[0]?.end && (
                                <>
                                  <span>Morning : </span>
                                  {hours[0]?.start} to {hours[0]?.end}
                                  <br/>
                                </>
                              )}
                              {hours[1]?.start && hours[1]?.end && (
                                <>
                                  <span>Evening : </span>
                                  {hours[1]?.start} to {hours[1]?.end}
                                </>
                              )}
                            </>
                          ) : (
                            <>Not available</>
                          )}
                        </span>
                      </li>
                  ))}
                </ul>
              ) : (
                <p className="text-white">No availability information provided</p>
              )}
            </div>
          </div>
        </motion.div>

        {/* Add more details as needed */}
      </div>
    </div>
  );
}

export default DoctorDetails;
